import { getRuntimeConfig } from "@/config/runtimeConfig";
import { jainElibraryAPI } from "@/projects/jain elibrary/services/jainElibraryApiClient";
import { axiosConfig } from "@/services/axiosConfig";

/** Apply API base URL from runtime config to shared axios instances. */
export function applyRuntimeClients(): void {
  const { apiUrl } = getRuntimeConfig();
  jainElibraryAPI.defaults.baseURL = apiUrl;
  axiosConfig.defaults.baseURL = apiUrl;
}
